/* eslint-disable */
//import jqueryGlobal from './jqueryGlobal.js';
//import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
//import { docReady } from '../utils.js';
//import { app, db } from './firebaseInit.js';
//import Alpine from 'alpinejs';
//import { PublicProfile, Organization, OrgPublicProfile, BBEvent, BBScheduledEvent } from './models/index.js';
//import Inputmask from 'inputmask';
//import { initAppPub } from './appPub.js';
//import relativeTime from 'dayjs/plugin/relativeTime';
//import dayjs from 'dayjs';
import { bbprivacy, bbterms } from './rodeoFloVariables.js';


async function initPage() {
	console.log('init pub privacy page');
	$('#privacy').html(bbprivacy);
	//initAppPub();
	//Alpine.start();
}

initPage()
